// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__3cHYR","burger":"Navbar_burger__2LrXr"};